<template>
  <div>
    <pc-header activeIndex="terms"></pc-header>
    <div class="container full-height h-100">
      <div class="row">
        <div class="col">
          <h3 class="mt-3">Terms and Conditions</h3>
<!--          <div class="el-tag el-tag&#45;&#45;warning">Beta Notice</div>-->
<!--          <div class="mt-2">No trial restrictions applied during beta stage. You are free to use the product until it is finally released. </div>-->
<!--          <div class="mt-2">Release plans will be announced separately via email and on the main page.</div>-->
<!--          <div class="mt-4">In order to use PyCharm extension, you should register own account.</div>-->
          <div class="mt-4">
            There are no specific usage conditions.
            You are free to use PyCrunch as test runner in both open-source and commercial projects.</div>
<!--          <h5 class="mt-4">Trial</h5>-->
<!--          <div class="c">After registration, free trial for 14 days will be activated.</div>-->
<!--          <div class="mt-2">You are free to use this extension on your projects during trial.</div>-->
<!--          <div class="mt-2">Trial can be activated only once per device.</div>-->
<!--          <h5 class="mt-4">Pricing</h5>-->
<!--          <div class="mt-2">PyCrunch supports two type of licenses: monthly and yearly. When purchasing monthly licence, auto-renewal option is enabled by default (which can be disabled before making payment).</div>-->
<!--          <div class="mt-2">-->
<!--            Price for monthly license is 4.99$.-->
<!--            It will be billed automatically each month before expiration day, if opted for auto-renewal.-->
<!--            If there is not sufficient credit on card during auto-update, you will be able to retry payment manually from profile page, you will be notified by email whether payment was successful.-->
<!--          </div>-->
<!--          <div class="mt-2">Yearly license is a one-time payment of 49.99$</div>-->
<!--          <div class="mt-2">When the license expires, you will have to buy another license in order to continue usage of the product. You can do this anytime from profile page.</div>-->
<!--          <h5 class="mt-4">Refund policy</h5>-->
<!--          <div>Refunds are possible within 7 days from payment date. Please contact support to request refund.</div>-->
          <h5 class="mt-4">Support</h5>
          <div class="mt-2">For any additional questions, bug reports and feature requests, please contact support team at:</div>
          <div class="mt-2"><a href="mailto:support@pycrunch.com">support@pycrunch.com</a></div>
          <div class="mt-2">Usually, it will take up to 24 hours on working days to process your request.</div>
          <div class="mt-5 pb-5 mb-5">PyCrunch Team.</div>

        </div>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
  import PcHeader from '../components/pc-header.component'
  import PcFooter from '../views/PcFooter'
  export default {
    name: 'pc-terms',
    components: {
      PcFooter,
      PcHeader},
  }
</script>

<style scoped>
  .full-height {
    min-height: 85.7vh;
    flex-direction: column;
  }
</style>